<template>
	<div id="Boot" :class="{ WithLogo: showLogo }" :key="i">{{getLinesVisible()}}</div>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import DefaultLayout from '../../layouts/Default/index.vue';
	import SoundManager from '../../util/soundManager.js';
		
	const lines = [
		
		'25MHz CPU Clock',
		'Starting MS-DOS...',
		'',
		'C:\\>',
		'C:\\>dir',
		' Directory of C:\\',
		' 01/04/2018  00:01 PM    <DIR>                .',
		' 01/04/2018  00:01 PM    <DIR>                ..',
		' 01/04/2018  00:01 PM                 133,337 HOMEY.EXE',
		'               1 File(s)',
		'               2 Dir(s)',
		'',
		'C:\\>HOMEY.EXE',
		'',
		'   Homey for MS-DOS',
		'   (c) 2018 Athom B.V.',
		'',
		'   Homey is starting, please wait ...',
			
	];

	@Component({
		components: {
			DefaultLayout,
		},
	})
	export default class ViewBoot extends Vue {
		
		i = 0
		showLogo = true
		
		constructor() {
			super();
		}
		
		mounted() {
			
			this._loadTimeout = setTimeout(() => {
				this.showLogo = false;
			
				this.i = 0;
				this._tickInterval = setInterval(this._onTick.bind(this), 150);
	
				SoundManager.play('boot');
			}, 1500);
		}
		
		destroyed() {
			if( this._tickInterval ) clearInterval(this._tickInterval);
			if( this._loginTimeout ) clearTimeout(this._loginTimeout);
		}
		
		_onTick() {
			this.i = this.i + 1;
			
			if( this.i === lines.length ) {
				return this._loginTimeout = setTimeout(() => {
					this.$router.push('devices');
				}, 3000)
			}
		}
		
		getLinesVisible() {
			return lines.slice(0, this.i).join('\n');
		}
		
	}
</script>

<style lang="scss">
#Boot {
	height: 100%;
	padding: 1vw;
	color: white;
    white-space: pre;
    font-weight: bold;
}

#Boot.WithLogo {
	background: url(/favicon.png) no-repeat center center;
}
</style>